/**
 * @generated SignedSource<<2f7dfafeb0b2dadb213313f197da79c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespRecentSales_user" | "PdpSharedBuyerProtectionBox_user" | "PdpSharedDetailShipping_user">;
  readonly " $fragmentType": "PdpRespShippingReturns_user";
};
export type PdpRespShippingReturns_user$key = {
  readonly " $data"?: PdpRespShippingReturns_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtectionBox_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespRecentSales_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f2b32dcca90a35076ea9e0150baf6d2f";

export default node;
